/* eslint-disable import/no-anonymous-default-export */
export default {
  translations: {
    HOME: {
      INITIAL_PAGE: "Página Inicial",
      UPDATED_AT: "Atualizado em",
      QUICK_ACCESS: "Acesso Rápido",
      SUPORT: "Suporte",
      CALL_CENTER: "Central de Atendimento",
      VEHICLE_ASSISTANCE: "Assistência de Veículos:",
      DOES_NOT_HAVE: "ainda não tem?",
      CHAT_WITH_COMMERCIAL: "Conheça e converse com nosso comercial.",
      GENERAL_DATA: "Dados Gerais",
      SEARCH: "Buscar",
      COMMERCIAL: "Comercial",
      LANGUAGE: "Idioma",
      QUICK_CONTACT: "Contato rápido",
      CONTACT_REGIONAL: "Regional",
      CONTACT_COMERCIAL: "Comercial",
      CONTACT_CENTRAL: "Central de Emergência 24h",
      VEHICLE_NOT_SELECTED: "Nenhum veículo selecionado",
    },
    TITLE: {
      DASHBOARD: "Dashboard gerencial",
      FILTERS: "Filtros",
      FILTER_CHARTS: "Filtro de gráficos",
      FILTER_PERIODS: "Período de busca",
      FILTER_GROUPS: "Grupo de veículos",
      MY_FLEET: "Minha Frota",
      MAP: "Mapa",
      MAIN_GRID: "Painel Geral (Grid)",
      DETAILED_POSITIONS: "Posições Detalhadas",
      DRIVERS_REGISTERED: "Motoristas Cadastrados",
      DRIVER_REGISTER: "Cadastro de Motorista",
      VEHICLES: "Veículos",
      LOGS: "Logs",
      CLIENT_SEARCH: "Pesquisa de clientes",
    },
    MENU: {
      HOME: "Home",
      RASTREAMENTO: "Rastreamento",
      GRUPOS: "Grupos",
      CONTROLE: "Controle",
      ATENDIMENTO: "Atendimento",
      RELATÓRIOS: "Relatórios",
      CADASTRO: "Cadastro",
      MANUTENÇÃO: "Manutenção",
      SISTEMA: "Sistema",
      "Cadastro de Grupos": "Cadastro de Grupos",
      "Cadastro de Veículos": "Cadastro de Veículos",
      "Motoristas Cadastrados": "Motoristas Cadastrados",
      "Veículos vinculados": "Veículos vinculados",
      "Vincular usuários aos grupos": "Vincular usuários aos grupos",
      "Pontos de Visita": "Pontos de Visita",
      "Cerca Eletrônica": "Cerca Eletrônica",
      "Área de Risco": "Área de Risco",
      "Minha Frota": "Minha Frota",
      "Posições Detalhadas": "Posições Detalhadas",
      "Radar": "Radar",
      "Veículo mais próximo": "Veículo mais próximo",
      "Deslocamento": "Deslocamento",
      "Posicionamento": "Posicionamento",
      "Distância Percorrida": "Distância Percorrida",
      "Visitas por veículos": "Visitas por veículos",
      "Veículos em visitas": "Veículos em visitas",
      "Controle de Velocidade": "Controle de Velocidade",
      "Protocolos de Atendimento": "Protocolos de Atendimento",
      "Logs": "Logs",
      "Veículo/Apelido": "Veículo/Apelido",
      "Dashboard de gestão": "Dashboard de gestão",
      "Perfil": "Perfil",
      "Alterar Senha": "Alterar Senha",
      "Visualizar Cliente": "Visualizar Cliente",
      "Usuários do Cliente": "Usuários do Cliente",
    },
    DASHBOARD_CHARTS: {
      VEHICLE_STATUS: "Status dos Veículos",
      DRIVER_RANKING: "Ranking de Motoristas",
      GREATER_CIRCULATION: "Maior Circulação",
      GREATER_IDLENESS: "Maior Ociosidade",
      IDLENESS_DESCRIPTION_ENGINE: "Motor Ligado",
      IDLENESS_DESCRIPTION_IDLE: "Parado",
      IDLENESS_DESCRIPTION_OFF: "Motor Desligado",
      OUTSIDE_WORK_HOURS: "Fora do Horário Comercial",
      OUTSIDE_WORK_HOURS_DESCRIPTION: "Fora do Horário Comercial",
      INSIDE_WORK_HOURS_DESCRIPTION: "Dentro do Horário Comercial",
      WEEKLY_CIRCULATION: "Circulação Semanal",
      SPEED_LIMIT: "Limite de Velocidade",
      TRANSIT_FINES: "Multas de Trânsito",
      SPEED_ABOVE_COMPANY_LIMIT: "Velocidade acima do limite da empresa",
      SPEED_UP_TO_20_PERCENT_ABOVE: "Velocidade até 20% acima do limite da via (infração média)",
      SPEED_BETWEEN_20_50_PERCENT_ABOVE: "Velocidade entre 20% e 50% acima do limite da via (infração grave)",
      SPEED_ABOVE_50_PERCENT: "Velocidade acima de 50% do limite da via (infração gravíssima)",
    },
    DASHBOARD: {
      ACTIVE_VEHICLES: "Veículos Ativos",
      TOTAL_ODOMETER: "Odômetro Total",
      WORK_HOURS_DISTANCE: "Km Horário Comercial",
      OUTSIDE_WORK_HOURS_DISTANCE: "Km Fora do Horário Comercial",
      ENGINE_TIME: "Tempo de Uso",
      IDLE_TIME: "Tempo Ocioso",
      OFF_TIME: "Tempo Desligado",
      SPEED_LIMIT_DISTANCE: "Ocorrências Acima do Limite da Via",
      COMPANY_SPEED_LIMIT_DISTANCE: "Ocorrências Acima do Limite da Empresa",
      TOTAL_FINES: "Multas",
    },
    TABLE_FINES: {
      DRIVER: "Motorista",
      DATE: "Data",
      VALUE: "Valor (R$)",
      PLATE: "Placa",
    },
    FLEET: {
      BACK: "Voltar",
      MAP: "Mapa",
      GRID_AND_MAP: "Grid + Mapa",
      ACTIONS: "Ações",
      VIEW_MAP: "Ver mapa",
      OPEN_GOOGLE_MAPS: "Abrir Google Maps",
      BLOCK: "Bloqueio",
      ANCHOR: "Âncora",
      COMMANDS: "Comandos",
      CREATE_VISIT_POINT: "Criar Ponto de Visita",
      AVAILABLE_COMMANDS: "Comandos disponíveis",
      COMMAND_SENT: "Comando enviado",
      VEHICLE: "Veículo",
      THIS_VEHICLE_HAS_BLOCK: "Este veículo possui bloqueio",
      COMMAND_HISTORY: "Histórico de comandos",
      HISTORY: "Histórico",
      NO_DATA_FOUND: "Nenhum dado encontrado para o período selecionado",
    },
    IGNITION: {
      ON: "Ligado",
      OFF: "Desligado",
    },
    SEARCH: {
      SEARCH: "Busca",
      INITIAL_DATE_TIME: "Data e hora inicial",
      FINAL_DATE_TIME: "Data e hora final",
      UPDATE_PAGE: "Atualizar página",
      UPDATE: "Atualizar",
      INITIAL_TIME: "Horário Inicial",
      FINAL_TIME: "Horário Final",
    },
    MAINTENANCE: {
      MAINTENANCE: "Manutenção",
      REGISTER: "Registrar",
      REMOVE: "Retirar",
      REGISTER_MAINTENANCE: "Registrar Manutenção",
      REMOVE_MAINTENANCE: "Retirar Manutenção",
    },
    COMMANDS: {
      SEND_COMMANDS: "Enviar Comandos",
      COMMANDS: "Comandos",
      COMMAND_HISTORY: "Histórico de Comandos",
      ANCHOR: "Âncora",
      BLOCK: "Bloqueio",
      UNLOCK: "Desbloqueio",
    },
    REPORTS: {
      REPORT_REQUEST: "Solicitação de relatório",
      NO_DATA_IN_RESPONSE: "A resposta não contém os dados necessários.",
      FILTER_VALIDATION: "Validação dos Filtros",
      ERROR_FETCHING_REPORT: "Erro ao buscar dados do relatório",
      SELECT_VEHICLE: "Selecione um veículo",
      VEHICLE_ACTIVITY_TITLE: "Relatório de Atividade Veicular",
    },
    REPORT_COLUMNS: {
      START: "Início",
      START_LOCATION: "Local Início",
      END: "Fim",
      END_LOCATION: "Local Fim",
      TOTAL_DISTANCE: "Distância total",
      TRAVEL_TIME: "Tempo Percurso",
      REST_TIME: "Tempo de descanso",
      AVG_SPEED: "Velocidade média",
      MAX_SPEED: "Velocidade máxima",
      DRIVER: "Motorista",
      PLATE: "Placa",
      DISTANCE: "Distância",
      DAY_OF_WEEK: "Dia da Semana",
      DATE: "Data",
      IGNITION_ON: "Início",
      ENGINE_TIME: "Tempo ligado",
      SAMPLES_ABOVE_SPEED: "Amostras acima da velocidade filtrada",
      SAMPLES_WITHIN_SPEED: "Amostras dentro da velocidade filtrada",
      DATE_TIME: "Data/Hora",
      STATUS: "Status",
      IGNITION: "Ignição",
      EVENT: "Evento",
      SPEED: "Velocidade",
      LOCATION: "Localização",
      DURATION: "Duração",
      TYPE: "Tipo",
      PROTOCOL: "Protocolo",
      DESCRIPTION: "Descrição",
      OPENING_DATE: "Data de Abertura",
      SERVICE_DATE: "Data de Atendimento",
      CLOSING_DATE: "Data de Fechamento",
      ATTENDANT: "Atendente",
      ACCOUNT: "Conta",
      USER: "Usuário",
    },
    ERRORS: {
      FETCH_DATA_ERROR: "Erro ao buscar dados",
      FETCH_VEHICLES_STATUS_ERROR: "Erro ao buscar status dos veículos:",
      COMMAND_EXECUTION_ERROR: "Erro ao executar comando",
      FETCH_GROUPS_ERROR: "Erro ao buscar grupos:",
      CONFIG_NOT_FOUND: "Não existe configuração para seu domínio. Envie e-mail para <a href='mailto:contato@mirus.com.br'>contato@mirus.com.br</a>.",
      EMAIL_OR_PASS_INVALID: "Credenciais incorretas. Tente novamente!",
      LOGIN_FAILED: "Não foi possível fazer o login. Verifique os dados utilizados.",
      EMAIL_FORMAT: "O email inserido não é válido",
      CONFIRM_PASS: "As senhas devem ser iguais",
      SEND_RECOVERY_MAILS: "Erro ao enviar senha. Tente novamente mais tarde.",
      USER_NOT_FOUND: "Usuário não encontrado",
      USER_NOT_SELECTED: "Selecione um login.",
      REQUIRED_FIELDS: "Preencha todos os campos",
      RESET_NOT_POSSIBLE: "Erro ao tentar resetar a senha, tente novamente",
      KEY_PASS_INVALID: "Chave não encontrada, clique no link recebido por e-mail",
      SEARCH_ERROR: "Erro na busca.",
      FETCH_DRIVER_LIST_ERROR: "Falha ao buscar lista de motoristas",
      DELETE_DRIVER_ERROR: "Falha ao excluir motorista",
      SAVE_DRIVER_ERROR: "Falha ao salvar dados do motorista",
      SAVE_LINK_ERROR: "Falha ao salvar vínculo do motorista",
      REMOVE_LINK_ERROR: "Falha ao remover vínculo do motorista",
    },
    COMMON: {
      CHART: "Gráfico",
      MIN: "Minimizar",
      MAX: "Maximizar",
      LOADING: "Carregando",
      SEARCH: "Buscar",
      SAVE: "Salvar",
      CLOSE: "Fechar",
      BACK: "Voltar",
      ERROR: "Erro",
      SUCCESS: "Sucesso",
      ATTENTION: "Atenção!!",
      NAME: "Nome",
      DOCUMENT: "Documento",
      PLATE: "Placa",
      CPF_CNPJ: "CPF/CNPJ",
      ID: "ID",
      TYPE: "Tipo",
      DESCRIPTION: "Descrição",
      DATE: "Data",
      NO_DATA_FOUND: "Nenhum dado encontrado",
    },
    LOGIN: {
      LOADING_SETTINGS: "Buscando configurações...",
      CONTACTS: "Contatos",
      SOWING_FUTURE: "Semeando Futuro",
      LOGIN: "Login",
      USER: "Usuário",
      PASSWORD: "Senha",
      FORGOT_PASSWORD: "Esqueceu sua senha?",
      ACCESS: "Acessar",
      ACCESSING: "Acessando...",
      SELECT_ACCOUNT: "Selecione uma conta vinculada ao login",
      ACCOUNTS: "Contas",
      BACK: "Voltar",
      NEW_PASSWORD: "Nova Senha",
      CONFIRM_PASSWORD: "Confirmar Senha",
      RESET_PASSWORD: "Redefinir Senha",
      RESETTING: "Redefinindo...",
      RESET: "Redefinir",
      PASSWORD_UPDATED_SUCCESS: "Senha atualizada com sucesso",
      GO_TO_LOGIN_TEXT: "Clique no botão para voltar ao início e logar com a nova senha",
      GO_TO_LOGIN: "Ir para o Login",
      PASSWORD_REMINDER: "Lembrete de senha",
      EMAIL: "Email",
      REMEMBER_PASSWORD: "Lembrar da senha",
      SENDING: "Enviando...",
      LOADING_TEXT: "Carregando...",
    },
    DRIVER: {
      NAME: "Nome",
      DOCUMENT: "Documento",
      FUNCTIONAL_REGISTRY: "Registro funcional",
      RE: "RE",
      IBUTTON_KEY: "Chave iButton",
      LICENSE_NUMBER: "Número CNH",
      LICENSE_CATEGORY: "Categoria CNH",
      CNH: "CNH",
      CNH_CATEGORY: "Categoria CNH",
      LICENSE_EXPIRATION: "Vencimento CNH",
      EXPIRATION: "Vencimento",
      BIRTH_DATE: "Data de nascimento",
      BIRTH: "Nascimento",
      MOBILE_PHONE: "Celular",
      CELL_PHONE: "Celular",
      REGISTER: "Cadastro de Motorista",
      LINKED: "Vinculado",
      PLATE: "PLACA",
      IMPORT_SUCCESS: "Importação realizada com sucesso",
    },
    CLIENT: {
      SEARCH_TITLE: "Pesquisa de clientes",
      FILL_FIELDS_TO_FILTER: "Preencha os campos para filtrar a busca",
      SOCIAL_NAME: "Razão Social",
      TRADE_NAME: "Nome Fantasia",
      PLATE_NICKNAME: "Apelido da Placa",
      CONTRACT_STATUS: "Status do Contrato",
    },
    LOGS: {
      OPERATION_TYPE: "Tipo Operação",
      SEARCH_BUTTON: "Pesquisar",
    },
    BUTTONS: {
      SAVE: "Salvar",
      CLOSE: "Fechar",
      CANCEL: "Cancelar",
      DELETE: "Excluir",
      SEARCH: "Buscar",
      BACK: "Voltar",
      UPDATE: "Atualizar",
    },
    VEHICLE_NICKNAME: {
      TITLE: "Veículo/Apelido",
      EDIT_NICKNAME: "Editar Apelido",
      PLATE: "Placa",
      NICKNAME: "Apelido",
      DELETE: "Excluir",
      CANCEL: "Cancelar",
      NICKNAME_OF_VEHICLE: "o apelido do veículo",
    },
    LINKED_VEHICLES: {
      TITLE: "Veículos Vinculados",
      FILTER_BY_GROUP: "Filtrar por Grupo",
      ALL_GROUPS: "Todos os grupos",
      FILTER_BY_PLATE: "Filtrar por Placa",
      ALL_PLATES: "Todas as placas",
      PLATE: "Placa",
      CURRENT_GROUP: "Grupo Atual",
      SELECT_A_GROUP: "Selecione um grupo",
      CHANGED: "alterado",
      NO_VEHICLES_FOUND: "Nenhum veículo encontrado",
      SAVE_CHANGES: "Salvar alterações",
      CANCEL_CHANGES: "Cancelar alterações",
      NOTHING_TO_SAVE: "Nada para salvar",
      NO_CHANGES_TO_SAVE: "Não há alterações para salvar.",
      NO_RESPONSE: "Sem resposta",
      FAILURES: "Falhas",
    },
    VIEW_MAP_FILTERS: {
      TITLE: "Radar",
      GROUPS: "Grupos",
      ALL_GROUPS: "Todos os grupos",
      VEHICLES: "Veículos",
      ALL_VEHICLES: "Todos os veículos",
      VIEW_VISITS: "Ver visitas",
      OPEN_VISUALIZATION: "Abrir visualização",
      HELP_TEXT: "Selecione os filtros e clique em Abrir visualização para abrir o mapa em tela cheia",
    },
    PROFILE: {
      TITLE: "Perfil",
      USER_PROFILE: "Perfil do usuário",
      PHONE: "Telefone",
      NAME_REQUIRED: "O nome é obrigatório.",
      EMAIL_REQUIRED: "O e-mail é obrigatório.",
      PHONE_REQUIRED: "O telefone é obrigatório.",
      PHONE_INVALID: "Telefone inválido. Formato esperado: (XX) XXXX-XXXX ou (XX) 9XXXX-XXXX.",
      UPDATING: "Atualizando...",
      UPDATED_SUCCESS: "Perfil atualizado com sucesso!",
      UPDATE_ERROR: "Ocorreu um erro ao tentar atualizar o perfil!",
      AVATAR_UPDATED: "Avatar atualizado, será atualizado após realizar login novamente",
    },
    DRIVER_PROFILE: {
      VEHICLES: "Veículos",
    },
    LOGS_CONTROL: {
      ID: "Id",
      TYPE: "Tipo",
      DESCRIPTION: "Descrição",
      DATE: "Data",
    },
    GROUPS: {
      PAGE_TITLE: "Cadastro de Grupos",
      LIST_TITLE: "Lista de Grupos",
      REGISTER_TITLE: "Dados do Grupo",
      DELETE_ERROR_TITLE: "Erro ao excluir",
      DELETE_ERROR_TEXT: "Grupo em uso, exclusão não permitida.",
      FILTERS: "Filtros",
      SELECT_GROUP: "Selecione um grupo",
      CURRENT_GROUP: "Grupo Atual",
      NO_VEHICLES_FOUND: "Nenhum veículo encontrado",
      ACTION_CONFIRMED: "Ação confirmada!",
      CONFIRM: "Confirmar",
      DESCRIPTION: "Descrição",
      DEFAULT: "Padrão",
      DEFINE_DEFAULT: "Definir Padrão",
      DELETE: "Excluir",
    },
    MODAL_VISITS: {
      TITLE: "Veículos Próximos",
      GRID: "Grade",
      MAP: "Mapa",
      PLATE: "Placa",
      MODEL: "Modelo",
      DISTANCE: "Distância (m)",
      LAST_POSITION: "Última Posição",
      EXPORT_PDF: "Exportar PDF",
      EXPORT_EXCEL: "Exportar Excel",
      NO_VEHICLES_NEARBY: "Nenhum veículo próximo encontrado",
    },
    VISIT_CONTROL: {
      TITLE: "Controle de Visitas",
      NEW_VISIT: "Nova Visita",
      EDIT_VISIT: "Editar Visita",
      VISIT_NAME: "Nome da Visita",
      ADDRESS: "Endereço",
      RADIUS: "Raio (m)",
      CATEGORY: "Categoria",
      SAVE_SUCCESS: "Visita salva com sucesso",
      DELETE_SUCCESS: "Visita excluída com sucesso",
    },
    VISIT_POINTS: {
      TITLE: "Pontos de Visita",
      POINT_NAME: "Nome do Ponto",
      COORDINATES: "Coordenadas",
      CREATED_AT: "Criado Em",
    },
    REGISTER_VEHICLE: {
      TITLE: "Cadastro de Veículos",
      VEHICLE_DATA: "Dados do Veículo",
      LICENSE_PLATE: "Placa",
      CHASSIS: "Chassi",
      MODEL: "Modelo",
      YEAR: "Ano",
      COLOR: "Cor",
      SAVE_SUCCESS: "Veículo salvo com sucesso",
    },
    CONTROL_POINTS: {
      TITLE: "Pontos de Controle",
      NEW_POINT: "Novo Ponto",
      POINT_NAME: "Nome do Ponto",
      DESCRIPTION: "Descrição",
      TYPE: "Tipo",
    },
    VEHICLES_CONFIG: {
      TITLE: "Configurações de Veículos",
      GENERAL: "Geral",
      NOTIFICATIONS: "Notificações",
      SPEED_LIMIT: "Limite de Velocidade",
      FUEL: "Combustível",
      MAINTENANCE: "Manutenção",
    },
    RISK_AREA: {
      TITLE: "Áreas de Risco",
      NEW_AREA: "Nova Área",
      AREA_NAME: "Nome da Área",
      DANGER_LEVEL: "Nível de Perigo",
      LOW: "Baixo",
      MEDIUM: "Médio",
      HIGH: "Alto",
      CRITICAL: "Crítico",
    },
    ELETRONIC_FENCES: {
      TITLE: "Cercas Eletrônicas",
      NEW_FENCE: "Nova Cerca",
      FENCE_NAME: "Nome da Cerca",
      FENCE_TYPE: "Tipo de Cerca",
      CIRCULAR: "Circular",
      POLYGONAL: "Poligonal",
      ACTIVE: "Ativa",
      INACTIVE: "Inativa",
      ALERT_ON_ENTRY: "Alerta ao Entrar",
      ALERT_ON_EXIT: "Alerta ao Sair",
    },
    VEHICLE_NEAREST: {
      TITLE: "Veículos Mais Próximos",
      SEARCH_RADIUS: "Raio de Busca",
      FOUND_VEHICLES: "Veículos Encontrados",
      NO_VEHICLES: "Nenhum veículo encontrado na área",
    },
    FILTERS_COMPONENT: {
      MINIMUM_DURATION: "Duração Mínima",
      TYPE: "Tipo",
      BOTH: "Ambos",
      VISIT_POINT: "Ponto de Visita",
      STOP_POINT: "Ponto de Parada",
      ALL: "Todos",
      COMPANY_SPEED_ONLY: "Somente velocidade da empresa",
      ROAD_SPEED_MODERATE: "Acima da velocidade da via - infração média",
      ROAD_SPEED_SERIOUS: "Acima da velocidade da via - infração grave",
      ROAD_SPEED_VERY_SERIOUS: "Acima da velocidade da via - infração gravíssima",
      ROAD_SPEED_ALL: "Acima da velocidade da via - infração (todos)",
      VEHICLE: "Veículo",
      ALL_VEHICLES: "Todos os veículos",
      DRIVERS: "Motoristas",
      ALL_DRIVERS: "Todos os motoristas",
      START: "Início",
      END: "Fim",
      START_DATE_TIME: "Data e hora início",
      END_DATE_TIME: "Data e hora fim",
      REPORTS: "Relatórios",
      DISPLAY: "Exibir",
      EXCEL: "Excel",
      PDF: "PDF",
    },
    CLIENT_DETAILS: {
      PAGE_TITLE: "Detalhe de cliente",
      VIEW_CLIENT: "Visualizar Cliente",
      FANTASY_NAME: "Nome Fantasia",
      SHORT_NAME: "Nome Abreviado",
      FULL_NAME: "Nome Completo",
      SOCIAL_NAME: "Razão Social",
      IDENTIFICATION: "Identificação",
      ADDRESS: "Endereço",
      ADDRESS_2: "Endereço 2",
      COMPANY_REGISTRATION: "Registro da empresa",
      PHONE_1: "Telefone 1",
      PHONE_2: "Telefone 2",
      OBSERVATION: "Observação",
      NUMBER: "Número",
      NEIGHBORHOOD: "Bairro",
      COMPLEMENT: "Complemento",
      STATE: "Estado",
      CITY: "Cidade",
      ZIP_CODE: "CEP",
      CNPJ: "CNPJ",
      STATE_REGISTRATION: "Inscrição Estadual",
      MUNICIPAL_REGISTRATION: "Inscrição municipal",
      SIMPLE_TAX_OPTANT: "Optante pelo Simples Nacional",
      PUBLIC_COMPANY: "Empresa Pública",
      YES: "Sim",
      NO: "Não",
    },
    TABLE: {
      DEFAULT: "Padrão",
      ACTIONS: "Ações",
      FILTER: "Filtrar",
      GLOBAL_SEARCH: "Pesquisa global",
      LOAD_DATA_ERROR: "Erro ao carregar os dados",
      SELECT_OPTION: "Selecione uma opção para exibir os dados.",
    },
    USER_NAV: {
      USER_PROFILE: "Perfil do Usuário",
      CHANGE_PASSWORD: "Alterar Senha",
      CLIENT_USERS: "Usuários do cliente",
      COMPANY: "Empresa",
      FILL_BOTH_FIELDS: "Preencha os dois campos",
      PASSWORDS_MUST_MATCH: "As duas senhas devem ser iguais",
      PASSWORD_CHANGED: "Senha alterada",
      PASSWORD_CHANGED_SUCCESS: "Senha alterada com sucesso",
      PASSWORD_CHANGE_ERROR: "Erro ao alterar a senha, tente novamente mais tarde",
    },
    DELETE_MODAL: {
      CONFIRM_DELETE: "Deseja realmente excluir?",
      OK: "Ok",
    },
    MESSAGE_MODAL: {
      WARNING: "Aviso!",
    },
    INFO_WINDOW: {
      VEHICLE: "Veículo",
      MODEL: "Modelo",
      MANUFACTURER: "Montadora",
      YEAR: "Ano",
      CATEGORY: "Categoria",
      ADDRESS: "Endereço",
      STATUS: "Status",
      EVENT: "Evento",
      DRIVER: "Motorista",
      IGNITION_BATTERY: "Ignição (Bateria)",
      GROUP: "Grupo",
      SPEED: "Velocidade",
      ODOMETER: "Odômetro",
      TIME_ELAPSED: "Quanto Tempo",
      TRACKER_BATTERY: "Bateria do Rastreador",
      VEHICLE_BATTERY: "Bateria do Veículo",
    },
    MAINTENANCES: {
      MAINTENANCE_ITEM: {
        DESCRIPTION: "Adicione o item que deseja ter controle de uso",
        INPUT_PLACEHOLDER: "Digite o nome do item",
        BTN_SAVE: "Salvar Novo",
        BTN_CANCEL: "Cancelar",
        FIELD_TABLE_ITEM: "Item",
        FIELD_TABLE_EDIT: "Editar",
        FIELD_TABLE_DELETE: "Excluir",
      }
    },
    TOOLTIPS: {
      DASHBOARD: "Visão geral de todos os dados da frota, incluindo status dos veículos, KPIs e gráficos de análise.",

      DASHBOARD_CARDS_ACTIVE_VEHICLES: "Indica a quantidade de veículos rastreados, conforme o filtro de grupo selecionado.",
      DASHBOARD_CARDS_TOTAL_ODOMETER: "Indica a soma dos odômetros dos veículos rastreados, conforme filtros de grupo e período selecionados.",
      DASHBOARD_CARDS_KM_BUSINESS_HOURS: "Indica a soma dos odômetros dos veículos rastreados que circularam dentro do horário comercial (padrão: segunda a sexta, das 08h às 18h). Conforme filtros de grupo e período selecionados.",
      DASHBOARD_CARDS_KM_OUTSIDE_HOURS: "Indica a soma dos odômetros dos veículos que circularam fora do horário comercial (padrão: antes das 8h ou após 18h em dias úteis, qualquer horário nos finais de semana). Conforme filtros de grupo e período selecionados.",
      DASHBOARD_CARDS_ENGINE_TIME: "Indica a soma dos tempos dos veículos ligados e em movimento, conforme filtros de grupo e período selecionados.",
      DASHBOARD_CARDS_IDLE_TIME: "Indica a soma dos tempos dos veículos ligados, porém parados (considerado a partir de 2 minutos no mesmo local). Conforme filtros de grupo e período selecionados.",
      DASHBOARD_CARDS_OFF_TIME: "Indica a soma dos tempos dos veículos desligados, conforme filtros de grupo e período selecionados.",
      DASHBOARD_CARDS_SPEED_LIMIT_DISTANCE: "Indica a quantidade de ocorrências registradas acima da velocidade regulamentar da via, conforme filtros de grupo e período selecionados.",
      DASHBOARD_CARDS_COMPANY_SPEED_LIMIT_DISTANCE: "Indica a quantidade de ocorrências registradas acima da velocidade definida pela empresa (padrão urbano: 80 km/h, padrão rodoviário: 120 km/h), conforme filtros de grupo e período selecionados.",

      DASHBOARD_CHARTS_VEHICLE_STATUS: "Demonstra a atividade dos veículos da frota (ligado, desligado, parado, em movimento) e pontua situações anômalas no rastreamento como problemas de GPS, atrasos de posicionamento e comunicação com o rastreador.",
      DASHBOARD_CHARTS_QUICK_CONTACTS: "Permite que o usuário tenha as opções de contato da Movyx na palma da mão. Contatos da filial regional, consultor Movyx e central de atendimento 24/7.",
      DASHBOARD_CHARTS_DRIVERS_RANKING: "Ranking de motorista ou veículo que pontua o condutor/veículo com a pior dirigibilidade, baseado em eventos e seus respectivos pesos. Útil para identificar comportamentos de risco na frota.",
      DASHBOARD_CHARTS_MOST_ACTIVE_VEHICLES: "Indicadores que apontam os veículos com maior circulação (veículo ligado em movimento). Métrica útil para equalizar o uso da frota e aumentar sua eficiência operacional.",
      DASHBOARD_CHARTS_MOST_IDLE_VEHICLES: "Fornece métricas sobre veículos com maior ociosidade (ligados sem movimento). Útil para redução de custos operacionais, aumento de eficiência e planejamento de manutenções.",
      DASHBOARD_CHARTS_OUTSIDE_HOURS_USAGE: "Indica o uso dos veículos fora do horário definido pela empresa (em km). Útil para identificar tanto uso indevido do veículo quanto situações excepcionais na operação.",
      DASHBOARD_CHARTS_WEEKLY_CIRCULATION: "Indicador que demonstra a soma da circulação dos veículos da frota por período (em km), segmentado por dias da semana (segunda a domingo).",
      DASHBOARD_CHARTS_SPEED_LIMIT_EXCESS: "Demonstra o quanto os veículos estão extrapolando a velocidade, seja a definida pela empresa ou a velocidade regulamentar da via. Útil para gestão de segurança.",

      MINHA_FROTA: "Consulte o status em tempo real de todos os veículos da sua frota com informações detalhadas de localização e operação. Visualize em mapa ou grid com filtros por placa, grupo, status, ignição, velocidade, motorista e localização.",
      POSICOES_DETALHADAS: "Acompanhe a posição detalhada de cada veículo com histórico de movimentação desde o início do dia. Permite aplicar filtros por outros períodos e realizar ações específicas.",
      GRID_JOURNEY_WORK: "Analise as jornadas de trabalho dos veículos com informações sobre rotas, durações e eficiência operacional. Visualize detalhes do trajeto de origem ao destino.",
      GRID_SPEED_CONTROL: "Monitore eventos de excesso de velocidade e velocidade acima do limite, gerando relatórios de segurança. Filtre por agrupamento de veículos, tipo de ocorrência e período de análise.",
      GRID_VISIT_AMOUNT: "Acompanhe pontos de visita e parada com análise de tempo gasto em cada local. Identifique quais veículos realizaram visitas com início, fim e duração de cada uma.",
      GRID_PERIOD_VISITS: "Visualize visitas agrupadas por período com estatísticas e métricas de desempenho. Filtre por tempo mínimo de permanência e período específico.",
      GRID_PROTOCOLS: "Consulte protocolos e procedimentos registrados para cada evento de operação. Inclui protocolos automáticos, gerados por evento ou por atendimento.",
      APELIDO: "Permite o usuário atribuir o Nome de um veículo, como um código de frota ou uma descrição",
      RADAR: "Visualização em mapa que se atualiza automaticamente com todos os veículos ativos, filtrado por grupos e períodos. Abre em janela independente do navegador.",
      VEICULO_MAIS_PROXIMO: "Funcionalidade de geolocalização que permite pesquisar o veículo mais próximo a um endereço, outro veículo ou ponto de visita. Inclui informações de distância e tempo de chegada.",
      CONTROL_POINT: "Gerencie pontos de controle e acesso, monitorando passagens e eventos associados. Permite cadastrar locais onde os veículos realizam paradas e visitas.",
      ELETRONIC_FENCES: "Configure e monitore cercas eletrônicas (geofences) para alertas de entrada e saída de zonas. Usada para segurança, controle de frotas e gestão logística.",
      RISK_AREA: "Identifique áreas de risco com base em histórico de eventos e comportamento de condução. O sistema sinaliza quando veículos entram ou saem da área delimitada.",
      VEHICLES_CONFIGURATION: "Configure propriedades e parâmetros dos veículos da frota, horários comerciais, limites de velocidade e outras referências.",
      DRIVERS_MANAGEMENT: "Gerencie dados de motoristas, documentos, histórico de eventos e desempenho. Inclua dados complementares e defina permissões de condução por veículo.",
      USERS_GROUPS: "Organize usuários em grupos para controle de acesso e permissões. Usuário principal pode criar e gerenciar acessos limitados de outros usuários.",
      VEHICLES_GROUPS: "Agrupe veículos por critérios operacionais para análise e gerenciamento simplificado. Configure parâmetros específicos, gere relatórios automatizados e defina referências.",
      VEHICLE_DETAILS: "Informações detalhadas do veículo incluindo especificações técnicas, documentação, histórico e localização. Visualize nível de bateria, status da ignição, velocidade, odômetro e street view.",
      DRIVER_DETAILS: "Dados completos do motorista com licenças, histórico de eventos e desempenho. Inclua informações complementares e permissões de condução.",
      REPORTS: "Gere relatórios customizados com dados de operação, segurança e eficiência da frota. Inclui deslocamento, posicionamento, distância percorrida, visitas e controle de velocidade.",
      SETTINGS: "Configure preferências do sistema, notificações e parâmetros de operação. Altere horários comerciais, limites de velocidade e outras configurações da frota.",
      USER_PROFILE: "Gerencie seu perfil de usuário, alterando dados pessoais e preferências. Também permite alterar senha e gerenciar informações da conta.",
      HELP: "Central de ajuda com documentação, tutoriais e suporte técnico. Acesso a informações sobre todas as funcionalidades do sistema.",
      POINT_OF_VISIT: "Cadastre locais onde os veículos realizam paradas e visitas (fornecedores, clientes, pontos de interesse). Facilita identificação quando endereço é substituído pelo nome do ponto.",
      USER_PROFILE_CLIENT: "Defina informações do usuário como dados pessoais e preferências de acesso.",
      COMPANY_INFO: "Exiba informações da empresa cadastrada, permitindo consultar os dados do registro.",
      CHANGE_PASSWORD: "Altere a senha do sua conta de usuário para maior segurança.",
      PROTOCOLS: "Tela que permite a consulta de protocolos gerados, sejam protocolos automáticos, gerados por evento, ou por atendimento.",
      LOGS: "Registro de Atividades (Log) - tela que permite realizar consultas de todas as atividades realizadas pelo usuário no sistema Movyx Safe.",
      GROUPS: "Tela que permite criar, editar e administrar Grupos de Veiculos e sua configuração específica, permitindo a geração de relatórios automatizados, e configuração de parâmetros e referências para relatórios e dashboards.",
      BIND_VEHICLES: "Permite alocar um veículo a um grupo. Também é possível realocar os veículos de um grupo para outro.",
      GROUP_USERS: "Gerencia a permissão dos usuários (criados dentro da conta do cliente) para visualizar e administrar grupos específicos.",
      POSITION: "Função que permite acessar o histórico de posicionamento do veículo para um período especificado.",
      DISTANCE: "Esta consulta permite determinar a distância total percorrida por um veículo em um intervalo de tempo específico, registrando os pontos de partida e chegada, incluindo seus respectivos locais de início e término.",
      MAINTENANCE_ITEM: "Tela usada para cadastrar e gerenciar os itens de manutenção, permitindo criar, editar, inativar e visualizar todos os componentes que fazem parte dos serviços.",
      MAINTENANCE_SCHEDULING: "Tela destinada ao agendamento das manutenções, onde o usuário define datas, veículos ou equipamentos, responsáveis e a periodicidade das intervenções que precisam ser realizadas.",
      MAINTENANCE_SHIPPING: "Tela voltada ao controle de envio e recebimento de peças ou equipamentos para manutenção externa, registrando remessas, transportadoras, prazos e o status logístico de cada item.",
      MAINTENANCE_REGISTER: "Tela responsável pelo registro detalhado das manutenções realizadas, incluindo descrição do serviço, peças utilizadas, horas trabalhadas, custos e o técnico responsável pela execução.",
      MAINTENANCE_PENDING: "Tela que lista todas as manutenções pendentes, permitindo filtrar, priorizar e acompanhar atividades que ainda precisam ser executadas, aprovadas ou agendadas no fluxo de manutenção.",
      MAINTENANCE_COMPLETED: "Tela que apresenta o histórico de manutenções concluídas, facilitando consultas, auditorias e a geração de relatórios sobre desempenho, custos e histórico dos equipamentos ou veículos.",
    },
  },
};